module.exports = "<div class=\"container-fluid\">\n    <div class=\"row footer-ribbon\">\n        <div\n            class=\"col-xs-6 text-xs-left\"\n            translate=\"footer.author\"\n            translate-value-author=\"<a href='http://github.com/Eluinhost' target='_blank'>Eluinhost / ghowden</a>\"\n        ></div>\n        <div\n            class=\"col-xs-6 text-xs-right\"\n            translate=\"footer.source\"\n            translate-value-link=\"<a href='http://github.com/Eluinhost/Match-Calendar' target='_blank'>Github</a>\"\n        ></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/footerBar/template.html
// module id = 166
// module chunks = 0